<template>
  <div class="flex flex-col">
    <div class="flex w-full flex-col text-right">
      <h4 class="mb-6 laptop:-mb-9">
        {{ data?.companyPage?.data?.attributes?.certificates_certificates }}
      </h4>
      <img
        class="hidden h-[52px] w-[106.65%] max-w-[unset] laptop:block"
        src="../../assets/img/certificates-line.png"
        alt="line"
      />
      <div class="rtl-grid grid grid-cols-3 gap-x-[7%] gap-y-10 tablet:grid-cols-4 laptop:mt-[30px] laptop:grid-cols-4">
        <div
          v-for="(badge, index) in data?.companyPage?.data?.attributes?.certificates_certificates_badge"
          :key="index || JSON.stringify(badge)"
          ref="awardsList1"
        >
          <ImageStrapi
            class="max-w-[91px] laptop:max-w-[160px]"
            :img="data?.companyPage?.data?.attributes?.certificates_certificates_badge[index]?.image"
          />
        </div>
      </div>
    </div>
    <div class="mt-6 flex w-full flex-col text-right laptop:mt-12">
      <h4 class="mb-6 laptop:-mb-9">{{ data?.companyPage?.data?.attributes?.certificates_awards }}</h4>
      <img
        class="hidden h-[52px] laptop:block w-[106.65%] max-w-[unset]"
        src="../../assets/img/certificates-line.png"
        alt="line"
      />
      <div class="rtl-grid grid grid-cols-3 gap-x-[7%] gap-y-10 tablet:grid-cols-4 laptop:mt-[30px] laptop:grid-cols-5">
        <div
          v-for="(badge, index) in data?.companyPage?.data?.attributes?.certificates_awards_badges"
          :key="index || JSON.stringify(badge)"
          ref="awardsList2"
        >
          <ImageStrapi
            class="max-w-[91px] laptop:max-w-[160px]"
            :img="data?.companyPage?.data?.attributes?.certificates_awards_badges[index].image"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { Companypage1DataKey } from "~/symbols/symbols";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";
const { promise } = useWaitForPageTransitionEnd();

const data = inject(Companypage1DataKey);

const awardsList1 = ref<HTMLElement[]>([]);

const awardsList2 = ref<HTMLElement[]>([]);

onMounted(() => {
  initAnimation();
});

const tweens: Array<GSAPTween> = [];

async function initAnimation() {
  await promise.value;

  tweens.push(
    gsap.from(awardsList1.value, {
      scrollTrigger: {
        trigger: awardsList1.value,
        start: "top 80%",
        end: "bottom 80%",
        toggleActions: "play none none none",
      },
      y: 30,
      opacity: 0,
      stagger: 0.1,
    }),
  );

  tweens.push(
    gsap.from(awardsList2.value, {
      scrollTrigger: {
        trigger: awardsList2.value,
        start: "top 80%",
        end: "bottom 80%",
        toggleActions: "play none none none",
      },
      y: 30,
      opacity: 0,
      stagger: 0.1,
    }),
  );
}

onBeforeUnmount(() => {
  tweens.forEach((tween) => tween.kill());
  tweens.length = 0;
});
</script>
<style lang="scss" scoped>
.rtl-grid {
  direction: rtl;
}
</style>
